import { version } from '../../../../../package.json';
var IntegrationStatusComponent = /** @class */ (function () {
    function IntegrationStatusComponent() {
        this._version = version;
    }
    return IntegrationStatusComponent;
}());
export { IntegrationStatusComponent };
